import { render, staticRenderFns } from "./LandingLayout.vue?vue&type=template&id=32a849b8&"
import script from "./LandingLayout.vue?vue&type=script&lang=js&"
export * from "./LandingLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports